import { Check } from "lucide-react";

const plans = [
  { id: "mensal", name: "Mensal", price: "30", period: "/mês", note: "Para experimentar", popular: false },
  { id: "trimestral", name: "Trimestral", price: "90", period: "/3 meses", note: "Equivale a R$30/mês", popular: false },
  { id: "semestral", name: "Semestral", price: "162", period: "/6 meses", note: "Economize 10%", popular: true },
  { id: "anual", name: "Anual", price: "300", period: "/12 meses", note: "Equivale a R$25/mês", popular: false },
];

const benefits = ["+100.000 conteúdos", "Qualidade 4K/FHD", "Sem travamentos", "Suporte 24h", "Sem fidelidade"];

export const Pricing = ({ onCta }) => (
  <section id="planos" data-testid="pricing-section" className="py-24 px-4 sm:px-6 bg-[#0F0F13]/50 border-y border-white/10">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-14">
        <p className="text-[#FF5A00] text-sm font-bold uppercase tracking-[0.25em] mb-3">Planos</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
          Escolha o plano ideal para você
        </h2>
        <p className="text-white/55 max-w-xl mx-auto text-base">
          Ativação imediata após o pagamento. Cancele quando quiser.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {plans.map((plan) => (
          <div
            key={plan.id}
            data-testid={`plan-${plan.id}`}
            className={`relative bg-[#0F0F13] border rounded-2xl p-8 flex flex-col transition-all duration-300 hover:-translate-y-1 ${
              plan.popular
                ? "border-[#FF5A00]/60 shadow-[0_0_40px_rgba(255,90,0,0.15)]"
                : "border-white/10 hover:border-white/25"
            }`}
          >
            {plan.popular && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#FF5A00] text-white text-xs font-bold uppercase tracking-wider px-4 py-1 rounded-full">
                Mais Popular
              </span>
            )}
            <h3 className="text-lg font-bold mb-1" style={{ fontFamily: "Outfit, sans-serif" }}>{plan.name}</h3>
            <p className="text-xs text-white/45 mb-5">{plan.note}</p>
            <div className="mb-6">
              <span className="text-sm text-white/60 align-top">R$</span>
              <span className="text-5xl font-black tracking-tighter" style={{ fontFamily: "Outfit, sans-serif" }}>{plan.price}</span>
              <span className="text-sm text-white/45">{plan.period}</span>
            </div>
            <ul className="space-y-2.5 mb-8 flex-1">
              {benefits.map((b, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-white/65">
                  <Check className="w-4 h-4 text-[#25D366] shrink-0" /> {b}
                </li>
              ))}
            </ul>
            <button
              data-testid={`cta-plan-${plan.id}`}
              onClick={() => onCta(plan.name)}
              className={`w-full font-bold rounded-lg py-3.5 transition-all ${
                plan.popular
                  ? "bg-[#FF5A00] hover:bg-[#FF7A33] text-white shadow-[0_0_20px_rgba(255,90,0,0.4)]"
                  : "bg-white/5 hover:bg-white/15 border border-white/15 text-white"
              }`}
            >
              Assinar Plano
            </button>
          </div>
        ))}
      </div>
    </div>
  </section>
);
